import { createContext, useContext, useEffect, useState, useCallback } from "react";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, toggleLang: () => {} });

const STORAGE_KEY = "winfield_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === "en" || stored === "sr" ? stored : "en";
  });

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") window.localStorage.setItem(STORAGE_KEY, next);
  }, []);

  const toggleLang = useCallback(() => {
    setLang(lang === "en" ? "sr" : "en");
  }, [lang, setLang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

// Helper that picks correct language from a bilingual object { en, sr }
export const useT = () => {
  const { lang } = useLanguage();
  return (obj) => {
    if (obj == null) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] ?? obj.en ?? "";
  };
};
